<div class="side-inner">
  <button title="close form" class="close-popup-button close-button modal-close" (click)="goBack()">close</button>
  <app-new-license-form [companyId]="companyId" [productCode]="productCode" [action]="action" [licenseId]="licenseId" id="licenseContainer" style="right: 0;" (closeForm)="goBack($event)"></app-new-license-form>
</div>
